/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import { useState } from "react"
import { useFormik } from "formik";
import * as Yup from "yup"
import { useNavigate } from "react-router-dom";
import { httpRequest } from "utils/httpRequest";
import Cookies from "js-cookie";
import { useAuth } from "context/AuthContext";
import { toast } from 'react-toastify';



const Login = () => {
  const { login } = useAuth()

  const [showPassword, setShowPassword] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);


  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({

    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Enter a valid email"
      )
      .required("Email is required"),

    password: Yup.string()
      .required('Password is required')
      .min(8, 'Password must be at least 8 characters'),
  })


  const formik = useFormik({
    initialValues: {
      email: "",
      password: ""
    },
    validationSchema,
    onSubmit: async (values) => {

      formik.setTouched({

        email: true,
        password: true,
      });

      const errors = await formik.validateForm();

      if (Object.keys(errors).length > 0) return false;

      setButtonLoading(true)
      try {
        const response = await httpRequest(
          "admin/login",
          "POST",
          {
            email: values?.email,
            password: values?.password,
          },
          {},
          false
        );
        if (response?.code === 200) {
          toast.success("Login Successful")
          const { token, user } = response;

          // console.log("token user", token, user)
          login(token, user)
          navigate("/")

        }

      } catch (error) {
        console.log(error);
      } finally {
        setButtonLoading(false)
      }

    }
  })

  const handleForgotPasswordClick = () => {
    navigate("/auth/forgot-password")
  }




























  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-5">
            {/* <div className="text-muted text-center mt-2 mb-3">
              <small>Sign in with</small>
            </div> */}
            <div className="btn-wrapper text-center">
              {/* <Button
                className="btn-neutral btn-icon"
                color="default"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <span className="btn-inner--icon">
                  <img
                    alt="..."
                    src={
                      require("../../assets/img/icons/common/github.svg")
                        .default
                    }
                  />
                </span>
                <span className="btn-inner--text">Github</span>
              </Button> */}
              {/* <Button
                className="btn-neutral btn-icon"
                color="default"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <span className="btn-inner--icon">
                  <img
                    alt="..."
                    src={
                      require("../../assets/img/icons/common/google.svg")
                        .default
                    }
                  />
                </span>
                <span className="btn-inner--text">Google</span>
              </Button> */}
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Sign in with credentials</small>
            </div>
            <Form role="form" onSubmit={formik.handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="email"
                    autoComplete="new-email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </InputGroup>

                {formik.touched.email && formik.errors.email && (
                  <div className="text-danger small mt-1">{formik.errors.email}</div>
                )}
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>

                  <Input
                    placeholder="Password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />

                  <InputGroupAddon addonType="append">
                    <InputGroupText
                      style={{ cursor: 'pointer' }}
                      onClick={() => setShowPassword((prev) => !prev)}
                    >
                      <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>

                {formik.touched.password && formik.errors.password && (
                  <div className="text-danger small mt-1">{formik.errors.password}</div>
                )}
              </FormGroup>
              {/* <div className="custom-control custom-control-alternative custom-checkbox">
                <input
                  className="custom-control-input"
                  id=" customCheckLogin"
                  type="checkbox"
                />
                <label
                  className="custom-control-label"
                  htmlFor=" customCheckLogin"
                >
                  <span className="text-muted">Remember me</span>
                </label>
              </div> */}
              <div className="text-center d-flex align-items-center justify-content-center">
                <Button className="mb-3 d-flex align-items-center justify-content-center" color="primary" type="submit" disabled={buttonLoading}>
                  {buttonLoading ? <span className="button-loader"></span> : "Login"}
                </Button>

              </div>
            </Form>
            <small onClick={handleForgotPasswordClick} style={{ cursor: "pointer" }}>Forgot password?</small>
          </CardBody>
        </Card>

      </Col>
    </>
  );
};

export default Login;
